import { render, staticRenderFns } from "./MasterKongTable.vue?vue&type=template&id=a51fccda&scoped=true&"
import script from "./MasterKongTable.vue?vue&type=script&lang=js&"
export * from "./MasterKongTable.vue?vue&type=script&lang=js&"
import style0 from "./MasterKongTable.vue?vue&type=style&index=0&id=a51fccda&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51fccda",
  null
  
)

export default component.exports